export default __webpack_public_path__ + "static/media/appIcon.70173044.svg";